module.exports = __webpack_public_path__ + "img/book_deep.2806a096.jpg";